module.exports = __webpack_public_path__ + "static/img/tst2-08.6ed815b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-08.jpg
// module id = l2o6
// module chunks = 1